"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const Tab_1 = __importDefault(require("@mui/material/Tab"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
const Popover_1 = __importDefault(require("@mui/material/Popover"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Link_1 = __importDefault(require("@mui/material/Link"));
const HighlightOff_1 = __importDefault(require("@mui/icons-material/HighlightOff"));
const styles_1 = require("@mui/material/styles");
const Tabs_1 = __importStar(require("@mui/material/Tabs"));
const x_data_grid_1 = require("@mui/x-data-grid");
const shared_1 = require("../shared");
const react_router_dom_2 = require("react-router-dom");
const react_draggable_1 = __importDefault(require("react-draggable"));
const react_cookie_1 = require("react-cookie");
const StyledTab = (0, styles_1.styled)(Tab_1.default)({
    '&.MuiTab-root': {
        textDecoration: 'none',
        textTransform: 'none',
        fontFamily: 'Poppins',
        fontSize: '1vmax',
    },
    '&.Mui-selected': {
        color: '#FFF',
        background: 'linear-gradient(180deg, #0146c7, #052d77)',
        fontFamily: 'Poppins',
        fontSize: '1.5vmax',
        fontWeight: '400',
    },
});
const StyledDataGrid = (0, styles_1.styled)(x_data_grid_1.DataGrid)((theme) => ({
    '& .MuiDataGrid-sortIcon': {
        opacity: 1,
        color: 'white',
    },
    '& .MuiDataGrid-menuIconButton': {
        opacity: 1,
        color: 'white',
    },
}));
const TabPanel = (props) => {
    const { children, value, index } = props, other = __rest(props, ["children", "value", "index"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ role: 'tabpanel', hidden: value !== index, id: `full-width-tabpanel-${index}`, "aria-labelledby": `full-width-tab-${index}` }, other, { children: value === index && (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { p: 1 } }, { children: children })) })));
};
const tabProps = (index) => {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
};
const DesmosSpreadsheet = () => {
    const { userId } = (0, react_router_dom_1.useParams)();
    const theme = (0, styles_1.useTheme)();
    const navigate = (0, react_router_dom_2.useNavigate)();
    const [registerData, setRegisterData] = (0, react_1.useState)(null);
    const [contentApi, setContentApi] = react_1.default.useState(null);
    const [testNameList, setTestNameList] = react_1.default.useState([]);
    const [desmosData, setDesmosData] = react_1.default.useState([]);
    const [tabValue, setTabValue] = react_1.default.useState(0);
    const [currentData, setCurrentData] = react_1.default.useState([]);
    const [alertOpen, setAlertOpen] = react_1.default.useState(false);
    const [popoverOpen, setPopoverOpen] = react_1.default.useState(false);
    const [openTutorial, setOpenTutorial] = react_1.default.useState(false);
    const [popoverdata, setPopoverdata] = react_1.default.useState({
        name: '',
        url: '',
        type: '',
    });
    (0, react_1.useEffect)(() => {
        initData();
    }, []);
    const compare = (a, b) => {
        if ((a === null || a === void 0 ? void 0 : a.TestName) === (b === null || b === void 0 ? void 0 : b.TestName)) {
            if ((a === null || a === void 0 ? void 0 : a.Module) === (b === null || b === void 0 ? void 0 : b.Module)) {
                const questionNoA = !isNaN(a === null || a === void 0 ? void 0 : a.QuestionNo) ? parseInt(a === null || a === void 0 ? void 0 : a.QuestionNo) : a === null || a === void 0 ? void 0 : a.QuestionNo;
                const questionNoB = !isNaN(b === null || b === void 0 ? void 0 : b.QuestionNo) ? parseInt(b === null || b === void 0 ? void 0 : b.QuestionNo) : b === null || b === void 0 ? void 0 : b.QuestionNo;
                return questionNoA - questionNoB;
            }
            else {
                return a === null || a === void 0 ? void 0 : a.Module.localeCompare(b === null || b === void 0 ? void 0 : b.Module);
            }
        }
        else {
            return a === null || a === void 0 ? void 0 : a.TestName.localeCompare(b === null || b === void 0 ? void 0 : b.TestName);
        }
    };
    const checkTutorial = () => {
        const cookies = new react_cookie_1.Cookies();
        const domain = (0, shared_1.getDomain)();
        const val = cookies.get('load-tutorial');
        if (val) {
            handleClick();
            cookies.remove('load-tutorial', domain);
        }
    };
    const initData = async () => {
        try {
            const regData = await (0, shared_1.getUserData)();
            setRegisterData(regData || null);
            const subData = await (0, shared_1.getDesmosSubscribed)(userId);
            if (!(subData === null || subData === void 0 ? void 0 : subData.isSubscribed)) {
                navigate(`/desmos-main-non/${userId}`);
            }
            const desmos = await (0, shared_1.getStrapiData)(`desmos-spreadsheets?&pagination[pageSize]=10000`);
            const attributesArray = desmos === null || desmos === void 0 ? void 0 : desmos.map((item) => {
                return Object.assign(Object.assign({}, item === null || item === void 0 ? void 0 : item.attributes), { id: item.id });
            });
            const sortedData = attributesArray.sort(compare);
            const distinctTestNames = [...new Set(sortedData === null || sortedData === void 0 ? void 0 : sortedData.map((item) => item === null || item === void 0 ? void 0 : item.TestName))];
            if (distinctTestNames.length > 0) {
                distinctTestNames.unshift('All');
            }
            setTestNameList(distinctTestNames);
            setDesmosData(sortedData || []);
            setCurrentData(sortedData || []);
            setContentApi(await (0, shared_1.getCmsURL)());
            checkTutorial();
        }
        catch (error) {
            console.error('Error fetching user data', error);
        }
    };
    const preventCopyPaste = (e) => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        handleSnackBarOpen();
    };
    const handleTabChange = (event, newValue) => {
        if (newValue != -1) {
            setTabValue(newValue);
            getChecklist(newValue);
        }
    };
    const handleSnackBarOpen = () => {
        setAlertOpen(true);
    };
    const handleSnackBarClose = () => {
        setAlertOpen(false);
    };
    const getChecklist = async (id) => {
        const testName = testNameList[id];
        const filterData = testName === 'All' ? desmosData : (desmosData || []).filter((item) => (item === null || item === void 0 ? void 0 : item.TestName) === testName);
        setCurrentData(filterData);
    };
    const renderImage = (data) => {
        const imageRegex = /!\[([^\]]*?)\]\(([^)]*?)\)/g;
        const newData = data === null || data === void 0 ? void 0 : data.replace(imageRegex, (match, altText, imageUrl) => {
            return `<img style='height: 90%; width: 90%;' alt='${altText}' src='${contentApi}${imageUrl}' />`;
        });
        return newData;
    };
    const handleLinkClick = (name, url, type) => {
        setPopoverdata({
            name: name,
            url: url,
            type: type,
        });
        handlePopoverOpen();
    };
    const handlePopoverOpen = () => {
        setPopoverOpen(true);
    };
    const handlePopoverClose = () => {
        setPopoverOpen(false);
    };
    const vhToPixels = (vh) => {
        return Math.round(window.innerHeight * (vh / 100));
    };
    const vwToPixels = (vw) => {
        return Math.round(window.innerWidth * (vw / 100));
    };
    const columns = [
        { field: 'TestName', headerName: 'Name', minWidth: 100, flex: 1, headerAlign: 'center', align: 'center' },
        { field: 'Module', headerName: 'Module', minWidth: 100, flex: 1, headerAlign: 'center', align: 'center' },
        { field: 'QuestionNo', headerName: 'Question #', minWidth: 100, flex: 1, headerAlign: 'center', align: 'center' },
        { field: 'DifficultyLevel', headerName: 'Difficulty', minWidth: 100, flex: 1, headerAlign: 'center', align: 'center' },
        {
            field: 'LinkToModule',
            headerName: 'Link To Module',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                var _a, _b;
                return ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.LinkToModule, target: '_blank' }, { children: (_b = params === null || params === void 0 ? void 0 : params.row) === null || _b === void 0 ? void 0 : _b.LinkToModuleName })));
            },
        },
        { field: 'CollegeBoardCategory', headerName: 'College Board Category', minWidth: 100, flex: 1, headerAlign: 'center', align: 'left' },
        { field: 'DesmosCategory', headerName: 'Desmos Category', minWidth: 100, flex: 1, headerAlign: 'center', align: 'left' },
        {
            field: 'DesmosLink',
            headerName: 'Desmos Link',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params) => {
                var _a;
                return ((0, jsx_runtime_1.jsx)(Link_1.default, Object.assign({ component: 'button', underline: 'always', onClick: () => { var _a; return handleLinkClick('Desmos Link', (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.DesmosLink, 'desmos'); } }, { children: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.DesmosLink })));
            },
        },
        {
            field: 'AdvancedDesmosLink',
            headerName: 'Advanced Desmos Link',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params) => {
                var _a;
                return ((0, jsx_runtime_1.jsx)(Link_1.default, Object.assign({ component: 'button', underline: 'always', onClick: () => { var _a; return handleLinkClick('Advanced Desmos Link', (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.AdvancedDesmosLink, 'ad_desmos'); } }, { children: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.AdvancedDesmosLink })));
            },
        },
    ];
    const handleClick = () => {
        setOpenTutorial(true);
    };
    const handleClose = () => {
        setOpenTutorial(false);
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'home-page-root', onCopy: (e) => preventCopyPaste(e), onPaste: (e) => preventCopyPaste(e), onCut: (e) => preventCopyPaste(e) }, { children: [(0, jsx_runtime_1.jsx)("img", { src: '/assets/background_3.png', alt: 'home-screen', className: 'bg_1_image', loading: 'lazy' }), (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { width: '100%', zIndex: 1 } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(AppBar_1.default, Object.assign({ position: 'static' }, { children: (0, jsx_runtime_1.jsxs)(Tabs_1.default, Object.assign({ value: tabValue, onChange: handleTabChange, textColor: 'inherit', "aria-label": 'full width tabs example', TabIndicatorProps: {
                                    style: {
                                        backgroundColor: '#000',
                                    },
                                }, variant: 'fullWidth', scrollButtons: true, sx: {
                                    [`& .${Tabs_1.tabsClasses.scrollButtons}`]: {
                                        '&.Mui-disabled': { opacity: 0.3 },
                                    },
                                    color: '#000',
                                    backgroundColor: '#FFF',
                                    fontFamily: 'Poppins',
                                    fontSize: '1.5vmax',
                                    fontWeight: '400',
                                } }, { children: [(0, jsx_runtime_1.jsx)(StyledTab, { onClick: handleClick, value: -1, label: 'View Tutorial', sx: { minWidth: 'fit-content', flex: 1, backgroundColor: '#6690B1', color: 'beige' } }, -1), (testNameList || []).map((tab, idx) => ((0, jsx_runtime_1.jsx)(StyledTab, Object.assign({ value: idx, label: tab, sx: { minWidth: 'fit-content', flex: 1 } }, tabProps(idx)), idx)))] })) })), (0, jsx_runtime_1.jsx)(TabPanel, Object.assign({ value: 0, index: 0, dir: theme.direction }, { children: (0, jsx_runtime_1.jsx)(Paper_1.default, Object.assign({ sx: { width: '100%' } }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { height: '75vh', width: '100%', overflowY: 'auto' } }, { children: (0, jsx_runtime_1.jsx)(StyledDataGrid, { rows: currentData, columns: columns, hideFooter: false, classes: { columnHeader: 'result_grid_header' } }) })) })) }), 0)] })) })), (0, jsx_runtime_1.jsx)(react_draggable_1.default, { children: (0, jsx_runtime_1.jsxs)(Popover_1.default, Object.assign({ id: 'popover-review', open: openTutorial, onClose: handleClose, classes: {
                        root: 'review_result_popup',
                    }, anchorReference: 'anchorPosition', anchorPosition: { top: vhToPixels(9), left: vwToPixels(2) }, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right',
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    }, hideBackdrop: false }, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, direction: 'row', justifyContent: 'space-between', alignItems: 'center', padding: 1 }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 10 }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '1.50vmax' } }, { children: (0, jsx_runtime_1.jsx)("b", { children: 'How to use the Desmos Assistant' }) })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'Close' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', onClick: handleClose }, { children: (0, jsx_runtime_1.jsx)(HighlightOff_1.default, { className: 'review_result_icon' }) })) })) }))] })), (0, jsx_runtime_1.jsx)(Stack_1.default, Object.assign({ direction: 'column', sx: { width: '35vw', height: '40vh', p: '4px 16px' } }, { children: (0, jsx_runtime_1.jsx)("iframe", { src: 'https://www.youtube.com/embed/rR3OsVk0krc?autoplay=1', title: popoverdata.name, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', sandbox: 'allow-same-origin allow-forms allow-popups allow-scripts allow-presentation', allowFullScreen: true, style: { width: '100%', height: '100%' } }) }))] })) }), (0, jsx_runtime_1.jsx)(Popover_1.default, Object.assign({ id: 'popover-review', open: popoverOpen, onClose: handlePopoverClose, classes: {
                    root: 'review_result_popup',
                }, anchorReference: 'anchorPosition', anchorPosition: { top: vhToPixels(9), left: vwToPixels(2) }, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                }, hideBackdrop: false }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', sx: { width: '95vw', height: '85vh', p: '4px 16px' } }, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, direction: 'row', justifyContent: 'space-between', alignItems: 'center' }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '1.5vmax' } }, { children: (0, jsx_runtime_1.jsx)("b", { children: popoverdata.name }) })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'Close' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ edge: 'end', color: 'inherit', "aria-controls": 'menu', "aria-haspopup": 'true', onClick: handlePopoverClose }, { children: (0, jsx_runtime_1.jsx)(HighlightOff_1.default, { className: 'review_result_icon' }) })) })) }))] })), (0, jsx_runtime_1.jsx)("iframe", { src: popoverdata.url, title: popoverdata.name, allowFullScreen: true, style: { width: '100%', height: '100%' } })] })) })), (0, jsx_runtime_1.jsx)(Snackbar_1.default, Object.assign({ autoHideDuration: 6000, onClose: handleSnackBarClose, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: alertOpen }, { children: (0, jsx_runtime_1.jsx)(Alert_1.default, Object.assign({ onClose: handleSnackBarClose, severity: 'warning', variant: 'filled', sx: { width: '100%' } }, { children: "Copying and pasting is not allowed!" })) }))] })));
};
exports.default = DesmosSpreadsheet;
